import { render, staticRenderFns } from "./PracticalWorkCreation.vue?vue&type=template&id=37fe55e8&scoped=true"
import script from "./PracticalWorkCreation.vue?vue&type=script&lang=js"
export * from "./PracticalWorkCreation.vue?vue&type=script&lang=js"
import style0 from "./PracticalWorkCreation.vue?vue&type=style&index=0&id=37fe55e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe55e8",
  null
  
)

export default component.exports